import {presetDimensions} from 'components/imaging/ResizedDasWebImage';
import PropTypes from 'prop-types';
import {Component} from 'react';
import {Form, Header, Image, Segment} from 'semantic-ui-react';
import bathIcon from '../images/bath-icon.svg';
import bedIcon from '../images/bed-icon.svg';
import carIcon from '../images/car-icon.svg';
import floorIcon from '../images/floor-icon.svg';
import landIcon from '../images/land-icon.svg';
import AgentBioContainer from './AgentBio/index';
import Area from './Area';
import './CustomiseTargetProperty.scss';
import EditableTitle from './EditableTitle';
import Optional from './Optional';
import PropertyHistoryContainer from './PropertyHistoryContainer';
import {PropertyImageGalleryContainer} from 'components/PropertyImageGallery';
import {DisclaimerText} from 'components/DisclaimerText';

export default class CustomiseTargetProperty extends Component {
  static propTypes = {
    singleLineAddress: PropTypes.string,
    bedrooms: PropTypes.number,
    bathrooms: PropTypes.number,
    carSpaces: PropTypes.number,
    landArea: PropTypes.number,
    floorArea: PropTypes.number,
    section: PropTypes.object.isRequired,
    reportType: PropTypes.string.isRequired,
    updateSectionValue: PropTypes.func.isRequired,
    updatePreferences: PropTypes.func.isRequired,
    pageContext: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
    propertyId: PropTypes.number,
    uploadPhotoList: PropTypes.arrayOf(PropTypes.string.isRequired),
    onUpload: PropTypes.func,
    selectedPhotoIndex: PropTypes.arrayOf(PropTypes.number),
    updateTargetPhoto: PropTypes.func,
    dataIsEdited: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const {selectedPhotoIndex} = this.props;

    this.state = {
      currentIndex: [
        selectedPhotoIndex[0],
        selectedPhotoIndex[1],
      ],
    };
  }


  updateReportTitle = (data) => {
    const {reportType, updateSectionValue, updatePreferences} = this.props;

    updateSectionValue(data.title, 'title');
    updatePreferences({'targetProperty.sectionData.title': data.title}, reportType);
  };

  onIndexChange = (galleryIdx) => (imageIndex) => {
    const currentIndex = [...this.state.currentIndex];
    const {images} = this.props;

    this.props.updateTargetPhoto(galleryIdx, images[imageIndex]);

    currentIndex[galleryIdx] = imageIndex;
    this.setState({currentIndex});
  };

  upload = (galleryIndex) => (files) => {
    this.props.onUpload(files, galleryIndex);
  };

  render() {
    const {
      propertyId,
      section,
      singleLineAddress,
      bedrooms,
      bathrooms,
      carSpaces,
      landArea,
      floorArea,
      images,
      dataIsEdited,
    } = this.props;

    const {currentIndex} = this.state;
    return (
      <div className="targetProperty">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Target Property</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3">
            <span className="disabled">Title</span>
            {dataIsEdited && <DisclaimerText/>}
          </Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                  onUpdateData={this.updateReportTitle}
                  title={section.sectionData.title}
                  isEnabled={true}
                  width="50%"
                  maxLength={32}/>
            </Form.Group>
          </Form>
            <div>
              <div className="single-line-address">
                <span>{singleLineAddress}</span>
              </div>
              <div className="top-row">
                <div className="attributes">
                  <div className="bedrooms attribute">
                    <Optional value={bedrooms}/>
                    <Image src={bedIcon}/>
                  </div>
                  <div className="bathrooms attribute">
                    <Optional value={bathrooms}/>
                    <Image src={bathIcon}/>
                  </div>
                  <div className="car-spaces attribute">
                    <Optional value={carSpaces}/>
                    <Image src={carIcon}/>
                  </div>
                  <div className="land-area attribute">
                    <Area area={landArea}/>
                    <Image src={landIcon}/>
                  </div>
                  <div className="floor-area attribute">
                    <Area area={floorArea}/>
                    <Image src={floorIcon}/>
                  </div>
                </div>
              </div>
              <div className="image-gallery-container">
                {[0, 1].map((galleryIndex) => (
                  <div className="gallery" key={galleryIndex}>
                    <PropertyImageGalleryContainer currentIndex={currentIndex[galleryIndex]}
                                                   images={images}
                                                   inlineGalleryProps={{
                                                     imageProps: {
                                                       size: 'large',
                                                     },
                                                   }}
                                                   key={galleryIndex}
                                                   objectContext="Target Property"
                                                   pageContext="Target Property"
                                                   propertyId={propertyId}
                                                   resizeProps={{
                                                     isResize: true,
                                                     resizeDimensions: presetDimensions.PROPERTY_TARGET
                                                   }}
                                                   onIndexChange={this.onIndexChange(galleryIndex)}
                                                   onUpload={this.upload(galleryIndex)}/>
                  </div>
                ))}
              </div>
              <PropertyHistoryContainer/>
              <AgentBioContainer/>
            </div>
        </Segment>
      </div>
    );
  }
}